// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectOrder_custom-select__AkuMu","header-select":"SelectOrder_header-select__Pw507"};